import React, { Fragment } from 'react'
import {
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box
} from '@mui/material'
import WarehouseMultiSelect from '../../pages/ProductOrigin/Components/WarehouseMultiselect'
import { SelectedWarehousesByOperation } from '../../interfaces/Producto/ProductOrigins'
import { Warehouse } from '../../interfaces'
import { Loading } from '../UI'
import { TypeOperation } from '../../interfaces/TypeOperation/TypeOperation'

interface Props {
  typeOperations: TypeOperation[]
  warehouses: Warehouse[]
  selectedWarehousesByOperation: SelectedWarehousesByOperation[]
  handleSelectedWarehouses: (
    typeOperationId: number,
    newSelected: number[]
  ) => void
  isLoading?: boolean
}

export const TypeOperationWarehousesTable: React.FC<Props> = ({
  typeOperations,
  warehouses,
  selectedWarehousesByOperation,
  handleSelectedWarehouses,
  isLoading = false
}) => {
  if (isLoading) {
    return (
      <Box display='flex' justifyContent='center' mt={2}>
        <Loading />
      </Box>
    )
  }

  return (
    <Fragment>
      <Typography variant='subtitle1' style={{ marginLeft: 10, marginTop: 20 }}>
        {
          'Según el tipo de almacenamiento seleccionado previamente, asigne almacenes a los tipos de operaciones:'
        }
      </Typography>

      <Paper variant='outlined' style={{ width: '100%', marginTop: 4 }}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Tipo Operación</TableCell>
              <TableCell>Almacenes Asignados</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {typeOperations?.map((item) => (
              <TableRow key={item.typeOperationId}>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <WarehouseMultiSelect
                    warehouses={warehouses || []}
                    selectedItems={
                      selectedWarehousesByOperation?.find(
                        (op) => op.typeOperationId === item.typeOperationId
                      )?.warehouseIds || []
                    }
                    setSelectedItems={(newSelected: number[]) =>
                      handleSelectedWarehouses(
                        item.typeOperationId,
                        newSelected
                      )
                    }
                    required={false}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Fragment>
  )
}
